import React from 'react';

import styled from 'styled-components';

import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';

type QuickReply = {
  id?: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
};

type Props = {
  replies: QuickReply[];
  disabled?: boolean;
};

export function QuickReplyList({ replies, disabled = false }: Props) {
  if (replies.length === 0) {
    return null;
  }

  return (
    <QuickReplyRow direction="row" spacing={1} alignItems="center">
      {replies.map((reply) => (
        <QuickReplyButton
          key={reply.id ?? reply.label}
          type="button"
          size="sm"
          onClick={reply.onClick}
          disabled={disabled || reply.disabled}
        >
          {reply.label}
        </QuickReplyButton>
      ))}
    </QuickReplyRow>
  );
}

const QuickReplyRow = styled(Stack)`
  flex-wrap: wrap;
`;

const QuickReplyButton = styled(SecondaryButton)`
  border-radius: 999px;
`;
